// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"TestimoniesList_pageHeader__36QoS"};